import { createConfig, configureChains } from 'wagmi';
import { arbitrum, arbitrumGoerli } from 'wagmi/chains';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';

import { WagmiConnectorIds } from './etherConnectorConfig';
import RPCConfig, { NetworkIds } from './rpcConfig';

const ALCHEMY_KEY = '2bqvlkqoZpQcEiJPcxOMP2_4nrK1VCqM';
const WALLET_CONNECT_PROJECT_ID = 'aa549fde6bb057685d2e4f408f3678f8';

export const ALCHEMY_URL = `https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_KEY}`;

const { publicClient, chains } = configureChains(
  [arbitrum, arbitrumGoerli],
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? [alchemyProvider({ apiKey: ALCHEMY_KEY }), publicProvider()]
    : [publicProvider()],
);

const coinbaseConnector = new CoinbaseWalletConnector({
  chains,
  options: {
    appName: 'Vesta Finance',
    chainId: NetworkIds.ARBITRUM_ONE,
    jsonRpcUrl: RPCConfig[NetworkIds.ARBITRUM_ONE].rpcUrls.default.http[0],
  },
});

const metaMaskConnector = new MetaMaskConnector({
  chains,
});

const walletConnectConnector = new WalletConnectConnector({
  chains,
  options: {
    projectId: WALLET_CONNECT_PROJECT_ID,
  },
});

const injectedProvider = new InjectedConnector({
  chains,
  options: {
    name: 'Injectable Wallets',
  },
});

const bitKeepProvider = new InjectedConnector({
  chains,
  options: {
    name: 'BitKeep',
    getProvider: () => {
      return typeof window !== 'undefined' && (window as any).bitkeep
        ? ((window as any).bitkeep.ethereum as any)
        : undefined;
    },
  },
});

export const wagmiClient = createConfig({
  publicClient,
  autoConnect: true,
  connectors: [
    metaMaskConnector,
    coinbaseConnector,
    walletConnectConnector,
    bitKeepProvider,
    injectedProvider,
  ],
});

export const Connectors = {
  [WagmiConnectorIds.METAMASK_ID]: wagmiClient.connectors[0],
  [WagmiConnectorIds.COINBASE_ID]: wagmiClient.connectors[1],
  [WagmiConnectorIds.WALLETCONNECT_ID]: wagmiClient.connectors[2],
  [WagmiConnectorIds.BITKEEP_ID]: wagmiClient.connectors[3],
  [WagmiConnectorIds.INJECTED_ID]: wagmiClient.connectors[4],
};
